import {
  AuthorSignDocumentDeviceStrategy,
  AuthorSignDocumentFileSystemStrategy,
  AuthorSignDocumentDepositSignLoginPswStrategy,
  AuthorSignDocumentDiiaStrategy,
  AuthorSignDocumentCloudKeyFileSystemStrategy,
  AuthorSignDocumentWithQrCloudProviderStrategy,
  AuthorSignDocumentWithIdCloudProviderStrategy
} from '@/sign/strategies/author-sign-document-private-key.strategy';
import { SignStrategyFactory } from './sign-strategy.factory';

export class AuthorSignDocumentStrategyFactory extends SignStrategyFactory {
  constructor() {
    super(
      AuthorSignDocumentFileSystemStrategy,
      AuthorSignDocumentDeviceStrategy,
      AuthorSignDocumentDepositSignLoginPswStrategy,
      AuthorSignDocumentDiiaStrategy,
      AuthorSignDocumentCloudKeyFileSystemStrategy,
      AuthorSignDocumentWithQrCloudProviderStrategy,
      AuthorSignDocumentWithIdCloudProviderStrategy);
  }
}
